import React, { useCallback, useEffect, useState } from 'react';
import LoadingSpinner from '../common/LoadingSpinner';
import { getPlatformCohorts } from '../../services/api';
import { formatPercent } from '../../utils/formatters';

// Когортная конверсия триал->оплата строится по всей истории organizations
// (см. database.get_cohort_conversion). Churn считается только с момента
// появления org_status_history — т.е. с деплоя этой фичи, поэтому пустой
// список churn — это нормально для свежей установки, а не баг.
const CohortsCard = () => {
  const [cohorts, setCohorts] = useState([]);
  const [churn, setChurn] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getPlatformCohorts();
      setCohorts(data.cohorts || []);
      setChurn(data.churn || []);
      setError('');
    } catch (e) {
      setError('Не удалось загрузить когорты');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  return (
    <section className="ui-card">
      <div className="ui-card-head">
        <h2>Когорты и churn</h2>
        <p>Конверсия — доля организаций когорты, оплативших хотя бы раз (независимо от текущего статуса).</p>
      </div>

      {loading && <LoadingSpinner />}
      {!loading && error && <div className="ui-inline-error">{error}</div>}

      {!loading && !error && (
        <>
          {cohorts.length === 0 ? (
            <div className="ui-empty">Пока нет ни одной когорты</div>
          ) : (
            <div className="platform-org-table">
              <div className="platform-org-row platform-cohort-header">
                <span>Когорта</span>
                <span>Регистраций</span>
                <span>Оплатили</span>
                <span>Конверсия</span>
              </div>
              {cohorts.map((c) => (
                <div className="platform-org-row" key={c.cohort}>
                  <span className="platform-org-name">{c.cohort}</span>
                  <span>{c.signups}</span>
                  <span>{c.converted}</span>
                  <span className="ui-badge">{formatPercent(c.conversion_rate * 100)}</span>
                </div>
              ))}
            </div>
          )}

          <div className="ui-card-head" style={{ marginTop: 'var(--s-5)' }}>
            <h3>Churn по месяцам</h3>
            <p>Знаменатель — приближённая оценка «активных на начало месяца», не бухгалтерская точность.</p>
          </div>
          {churn.length === 0 ? (
            <div className="ui-empty">Данные накапливаются — записей ещё нет</div>
          ) : (
            <div className="platform-org-table">
              {churn.map((c) => (
                <div className="platform-org-row" key={c.month}>
                  <span className="platform-org-name">{c.month}</span>
                  <span>{c.churned} ушло</span>
                  <span className={`ui-badge ${c.churn_rate > 0.1 ? 'ui-text-danger' : ''}`}>{formatPercent(c.churn_rate * 100)}</span>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </section>
  );
};

export default CohortsCard;
